import axios from 'axios';
import _ from 'lodash';
import Swal from 'sweetalert2';
import mitt from 'mitt'
import moment from 'moment'

const emitter = mitt()

window.emitter = emitter

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window._ = _;

window.Swal = Swal.mixin({
    customClass: {
        confirmButton: "btn-primary",
        cancelButton: "btn-default"
    },
    buttonsStyling: false,
});


window.moment = moment;

let inscope = document.head.querySelector('meta[name="in-scope"]');

if (inscope) {
    window.inScopeFeatures = JSON.parse(inscope.content);
} else {
    console.error('NO INSCOPE DATA AVAILABLE');
}

window.trans = key => _.get(window.i18n, key, key);


$(function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var loading = false;

    var submitForm = _.once(function () {
        $("#checkout-form").submit();
    });

    $('.payment-method-selection').on('click', 'button', (e) => {

        e.preventDefault();
        $('#payment_method').val(e.target.name);

        if (!loading) {
            loading = true;
            $('.payment-method-selection button').css('cursor', 'wait');
            submitForm();
        }
    });

});
